<template>
  <!-- External link -->
  <a
    :class="['button', variant ? `button--${variant}` : null]"
    :href="url"
    target="_blank"
    v-if="external"
  >
    {{ text }}
    <Icon id="external-link" />
  </a>

  <!-- Internal link -->
  <router-link
    :class="['button', variant ? `button--${variant}` : null]"
    :to="url"
    v-else
  >{{ text }}</router-link>
</template>

<script>
import Icon from '@/components/Icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    variant: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    external: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  margin-bottom: 12px;
  padding: 13px 15px 9px;
  display: block;
  font-family: $font-bold;
  text-align: center;
  text-decoration: none;
  border: 1px solid transparent;

  &--primary {
    background-color: $color-primary;
    color: $color-black;
  }

  &--secondary {
    color: $color-secondary-light;
    border-color: $color-secondary-light;
  }

  .icon {
    width: 18px;
    height: 18px;
    margin-left: 5px;
  }
}
</style>
